module.exports = __webpack_public_path__ + "img/secure_files.84b4c54a.png";